import {Stack, Typography} from '@mui/material';
import React from 'react';

import {HighlightedText} from 'presentation/components';
import {formatText} from 'presentation/utils';
import {UnitCardHeaderProps} from './types';

export function UnitCardHeader({unitName, query}: UnitCardHeaderProps) {
	return (
		<Stack justifyContent="space-between">
			<Typography variant="subtitle1" fontWeight={600} lineHeight={1} color="primary">
				<HighlightedText text={formatText(unitName)} highlight={query} />
			</Typography>
		</Stack>
	);
}
